import {
  vArray,
  vBoolean,
  vISODateTime,
  vNonEmptyString,
  vObject,
  vOneOf,
  vOptional,
  type vOutput,
  vPicklist,
  vPipe,
  vString,
} from '../validation/index.ts'

export const carrierLocationStatusTypes = [
  'new', // unprovisioned
  'error', // provisoining returned an error
  'active', // provisioned / can get rates
  'testing', // pending a successful rate before activating
  'none', // no account / cannot get rates
] as const
export type CarrierLocationStatusType =
  (typeof carrierLocationStatusTypes)[number]

export const carrierModeTypes = ['ltl', 'parcel', 'tl'] as const
export type AccountCarrierMode = (typeof carrierModeTypes)[number]

export const credentialDetailSchema = vObject({
  type: vNonEmptyString(),
  value: vOneOf([vBoolean(), vString()]),
  expires: vOptional(vPipe(vString(), vISODateTime())),
})

export type CredentialDetail = vOutput<typeof credentialDetailSchema>

const detailsArraySchema = vArray(credentialDetailSchema)
export const accountCarrierCredentialSchema = vObject({
  details: detailsArraySchema,
})

export type UpdateAccountCarrierCredentialDto = vOutput<
  typeof accountCarrierCredentialSchema
>

export const updateAccountCarrierLocationSchema = vObject({
  status: vOptional(vPicklist(carrierLocationStatusTypes)),
  details: vOptional(vArray(credentialDetailSchema)),
  overrides: vOptional(
    vObject({
      city: vOptional(vString()),
      postalCode: vOptional(vString()),
    }),
  ),
})
export type UpdateAccountCarrierLocationDto = vOutput<
  typeof updateAccountCarrierLocationSchema
>
